export default "__VITE_ASSET__CbhOSg3x__"